import { render } from "./InvestmentPolicyAdvisor.vue?vue&type=template&id=004f5adc&scoped=true"
import script from "./InvestmentPolicyAdvisor.vue?vue&type=script&lang=js"
export * from "./InvestmentPolicyAdvisor.vue?vue&type=script&lang=js"

import "./InvestmentPolicyAdvisor.vue?vue&type=style&index=0&id=004f5adc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004f5adc"]])

export default __exports__